import * as yup from 'yup';
import { TextComponentSchema } from '../../common';

export const IndividualTextSuggestionSchema = yup.object({
  textComponents: yup.array().of(TextComponentSchema).default([]),
});

export type IIndividualTextSuggestion = yup.InferType<typeof IndividualTextSuggestionSchema>;
